/**
 * Generated from ch7_p03.fla
 */
export function ch7_p03(this: Ich7_p03) {
	const bg = this.bg;
	ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const bubble = this.bubble;
	ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bubble.call(this.bubble);
	bubble.x = 833;
	bubble.y = 258.75;
	bubble.width = 1206.00;
	bubble.height = 517.50;
	bubble.alpha = 1.00;
	if (bubble.onLayout) bubble.onLayout();
	const bubbleBlur = this.bubbleBlur;
	ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bubbleblurr.call(this.bubbleBlur);
	bubbleBlur.x = 833;
	bubbleBlur.y = 258.75;
	bubbleBlur.width = 1206.00;
	bubbleBlur.height = 517.50;
	bubbleBlur.alpha = 1.00;
	if (bubbleBlur.onLayout) bubbleBlur.onLayout();
	const holly = this.holly;
	ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_holly.call(this.holly);
	holly.x = 551.5;
	holly.y = 768;
	holly.width = 300.00;
	holly.height = 478.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const frameRight = this.frameRight;
	ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 353.50;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframerlines.call(this.linesRight);
	linesRight.x = 1663;
	linesRight.y = 516.25;
	linesRight.width = 80.00;
	linesRight.height = 286.50;
	linesRight.alpha = 0.50;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 343.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframellines.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 627.75;
	linesLeft.width = 95.00;
	linesLeft.height = 221.50;
	linesLeft.alpha = 0.50;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bg(this: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p03_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bubble(this: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bubble) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p03_bubble", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bubbleblurr(this: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bubbleblurr) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p03_bubbleblurr", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_holly(this: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p03_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframeRframe(this: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframerlines(this: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframerlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("rlines", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframeLframe(this: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframellines(this: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframellines) {
	if (this.setLayoutTexture) this.setLayoutTexture("llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich7_p03Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich7_p03Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich7_p03Sprite extends Ich7_p03Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich7_p03Text extends Ich7_p03Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich7_p03Polygon extends Array<number> {
}
interface Ich7_p03 {
	readonly bg: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bg;
	readonly bubble: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bubble;
	readonly bubbleBlur: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bubbleblurr;
	readonly holly: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_holly;
	readonly frameRight: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframeRframe;
	readonly linesRight: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframerlines;
	readonly frameLeft: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframeLframe;
	readonly linesLeft: Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframellines;
}
interface Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bg extends Ich7_p03Sprite {
}
interface Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bubble extends Ich7_p03Sprite {
}
interface Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_bubbleblurr extends Ich7_p03Sprite {
}
interface Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_holly extends Ich7_p03Sprite {
}
interface Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframeRframe extends Ich7_p03Sprite {
}
interface Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframerlines extends Ich7_p03Sprite {
}
interface Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframeLframe extends Ich7_p03Sprite {
}
interface Ich7_p03_hh_ch7_72dpi_p0304psdAssetchp7_p03_wcframellines extends Ich7_p03Sprite {
}
